import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LegalLinksService } from '../../constants/legal-links';
import { CookieConsentService } from '../../services/cookie-consent.service';
import { IonicModule } from '@ionic/angular';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
    selector: 'app-cookie-banner',
    templateUrl: './cookie-banner.component.html',
    styleUrls: ['./cookie-banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        IonicModule,
        AsyncPipe,
        TranslatePipe,
    ],
})
export class CookieBannerComponent {
  private readonly consentService = inject(CookieConsentService);
  /** Public: the banner links to the portal-hosted privacy policy from the template. */
  readonly legal = inject(LegalLinksService);

  readonly consent$ = this.consentService.consent$;

  showDetails = false;
  functionalEnabled = true;

  toggleDetails(): void {
    this.showDetails = !this.showDetails;
  }

  acceptAll(): void {
    this.consentService.acceptAll();
  }

  acceptEssential(): void {
    this.consentService.acceptEssential();
  }

  saveSettings(): void {
    this.consentService.update(this.functionalEnabled);
  }
}
